angular.module 'zc.projects'

.directive 'zcLabelCampaignSegment', ($translate) ->
  directive =
    restrict: 'A'
    require: '?ngModel'
    scope: {
      campaign: '=ngModel'
    }
    link: (scope, element, attrs) ->
      $(element).addClass('label')

      segmentClass = ''
      txt = ''

      switch scope.campaign.campaign_target
        when 'new_user'
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.newUser')
          segmentClass = 'segment-new'
        when 'repeat'
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.repeat')
          segmentClass = 'segment-repeat'
        when 'no_cv'
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.noCv')
          segmentClass = 'segment-no'
        when 'one_cv'
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.oneCv')
          segmentClass = 'segment-one_cv'
        when 'loyal_user'
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.loyalUser')
          segmentClass = 'segment-loyal_user'
        when 'all'
          txt = $translate.instant('projectsCampaigns.directives.labelCampaignSegment.all')
          segmentClass = 'segment-all'
        else

      $(element).addClass(segmentClass)
      $(element).text(txt)

  directive



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/label_campaign_segment.js.coffee